//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AboutPerson',
  props: {
    name: {
      type: String,
      required: true
    },
    position: {
      type: String,
      required: true
    },
    avatar: {
      type: String,
      required: true
    },
    linkedIn: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  computed: {
    image () {
      return require(`../../assets/img/avatars/${this.avatar}.png`)
    }
  }
}
